<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="4" v-if="paket.fileKAK !== ''">
              <v-label>Dokumen KAK</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileKAK', paket.fileKAK, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col>
            <v-col cols="4" v-if="paket.fileLampiran !== ''">
              <v-label>Dokumen Lampiran</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileLampiran', paket.fileLampiran, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col>
            <v-col cols="4" v-if="paket.fileLain !== ''">
              <v-label>Dokumen Tambahan</v-label>
              <v-btn icon color="green" 
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileLain', paket.fileLain, null)"><v-icon>get_app</v-icon></v-btn>
            </v-col>
            <!-- kegiatanId, {Filelain, FileLampiran, FileKAK},  -->
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { TenderLib } from "./../../../lib/tenderLib";
export default {
  data() {
    return {
      tenderLib: TenderLib,
    }
  },
  computed: {
    paket: function() {
      return this.$store.getters['lelang/paket']
    },
  }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>